export const FlangeData = [
  {
    id: 1,
    img: require("../Images/FlangeImg/img1.jpg"),
    heading: "ANSI Norm Flanges",
    link: "/ANSI_Norm_Flanges",
    text: "We stock huge inventories of all our products in all standard sizes to ensure timely delivery.",
  },
  {
    id: 2,
    img: require("../Images/FlangeImg/img2.jpg"),
    heading: "UNI Norm Flanges",
    link: "/UNI_Norm_Flanges",
    text: "We stock huge inventories of all our products in all standard sizes to ensure timely delivery.",
  },
  {
    id: 3,
    img: require("../Images/FlangeImg/img3.jpg"),
    heading: "EN Norm Flanges",
    link: "/EN_Norm_Flanges",
    text: "All our products go through various quality checks from procurement to final delivery.",
  },
  {
    id: 4,
    img: require("../Images/FlangeImg/img4.jpg"),
    heading: "BS Norm Flanges",
    link: "/BS_Norm_Flanges",
    text: "We stock huge inventories of all our products in all standard sizes to ensure timely delivery.",
  },
  {
    id: 5,
    img: require("../Images/FlangeImg/img5.jpg"),
    heading: "JIS Norm Flanges",
    link: "/JIS_Norm_Flangess",
    text: "We stock huge inventories of all our products in all standard sizes to ensure timely delivery.",
  },
  {
    id: 6,
    img: require("../Images/FlangeImg/img6.jpg"),
    heading: "DIN Norm Flanges",
    link: "/DIN_Norm_Flanges",
    text: "All our products go through various quality checks from procurement to final delivery.",
  },
];

export const FlangeOptionsData = [
  {
    id: 1,
    
    grade: "ANSI Norm Flanges",
    link: "/ANSI_Norm_Flanges",
   
  },
  {
    id: 2,
    img: require("../Images/FlangeImg/img2.jpg"),
    grade: "UNI Norm Flanges",
    link: "/UNI_Norm_Flanges",
    
  },
  {
    id: 3,

    grade: "EN Norm Flanges",
    link: "/EN_Norm_Flanges",
  },
  {
    id: 4,

    grade: "BS Norm Flanges",
    link: "/BS_Norm_Flanges",
  },
  {
    id: 5,
    
    grade: "JIS Norm Flanges",
    link: "/JIS_Norm_Flangess",
   
  },
  {
    id: 6,
    
    grade: "DIN Norm Flanges",
    link: "/DIN_Norm_Flanges",
    
  },
];
export const ENNormFlangesData = [
  {
    text1:
      "EN Norm Flanges Manufacturers,Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Modi metals inside business is the making of Type 01 Flange for the water and gas exporter oversee, sewage treatment and fire certification. Additionally, Dipti Metal Industries has made strong brands producer valves and controls for water treatment, dams and records, HVAC, headway organizing, marine and other mechanical parts. Dipti Metal Industries things are depended on to the certifiable intensive measures and are sold in more than countries around the globe. While dealing with the Dipti Metal Industries expect quality, steadfast quality, handiness and long lifetime in advantage.",
    text3: "",
   
    Specification: [
      "Forged stainless steel material conforms to ASME A182",
      "Forged stainless steel flange dimensions conform to ASME B16.5",
      "NPT Threads conform to ASME B1.20.1",
      'Up to 12" Listed',
    ],
    img: require('../Images/FlangeImg/img8.jpg'),
    Specifications: {
      "STAINLESS STEEL FLANGE":
        "ASTM / ASME SA 182 F 304, 304L, 304H, 309H, 310H, 316, 316H, 316L, 316 LN, 317, 317L, 321, 321H, 347, 347 H",
      Range:
        "15 NB upto 600 NB in 150 LBS, 300 LBS, 400 LBS, 600 LBS, 900 LBS, 1500 LBS, 2500 LBS / TABLE 2.5, TABLE 6, TABLE 10, TABLE 16, TABLE 25, TABLE 40, TABLE 64, TABLE 160, TABLE 320, TABLE 400",
      "Form:":
        "Slip on, socket weld, blind, lapped, screwed, weld neck, reducing, spectacle, slip on boss, plate, plate blank, screwed boss. ",
    
    },
    chemical: {
      grade:
        "Stainless Steel Pr EN 1092-1 Flanges| Carbon Steel Pr EN 1092-1 Flanges| Nickel Alloys Pr EN 1092-1 Flanges",
      "Size :": "DN15 - DN2000",
      "Standard: ": "EN 1092",
      "Type:":
        "Weld Neck Flanges(Raised Face), EN Norm flanges, Loose Flanges, Plate Flanges, Blind Flanges Process: Forged, Stamped",
      "Pressure grade:": "PN6, PN10, PN16, PN25, PN40",
    },
    products_Flanges: {
      PlateFlanges: [
        " EN 1092-1 Type 01 PN6",

        "EN 1092-1 Type 01 PN10",

        "EN 1092-1 Type 01 PN16",

        "EN 1092-1 Type 01 PN25",

        "EN 1092-1 Type 01 PN40",

        "EN 1092-1 Type 02 PN16",
      ],
      Welding_Neck_Flanges: [
        "EN 1092-1 Type 11 PN6",

        "EN 1092-1 Type 11 PN10",

        " EN 1092-1 Type 11 PN16",

        "EN 1092-1 Type 11 PN25",

        "EN 1092-1 Type 11 PN40",
      ],
      ThreadedFlanges: ["  EN 1092-1 Type 13 PN6", "EN 1092-1 Type 13 PN16"],
      Blind_Flanges: [
        "EN 1092-1 Type 05 PN6",

        "EN 1092-1 Type 05 PN10",

        "EN 1092-1 Type 05 PN16",
      ],
    },
  },
];

export const BSNormFlangesData = [
  {
    text1:
      "BS Norm Flanges Manufacturers,Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Modi metals is a dynamic group, which was set up completed 10 years back to oblige creating solicitations of BS 4504/BS 10 Flanges gages in BS Norm Flanges, Blind Flanges, Threaded Flanges, Loose or Lap Joint Flanges in all materials like Stainless Steel , Carbon Steel and High Nickel Alloys. We Manufacture, Export and Supply Flanges which meets with national and all-inclusive quality models and making base which has supplies changing in accordance with overall specific level and is particularly equipped with a whole game plan of forefront plasma refining sorts of rigging.",
    text3: "",
    img:require('../Images/FlangeImg/img9.png'),
    Specifications: {
      "STAINLESS STEEL FLANGE":
        "ASTM / ASME SA 182 F 304, 304L, 304H, 309H, 310H, 316, 316H, 316L, 316 LN, 317, 317L, 321, 321H, 347, 347 H",
      Range:
        "15 NB upto 600 NB in 150 LBS, 300 LBS, 400 LBS, 600 LBS, 900 LBS, 1500 LBS, 2500 LBS / TABLE 2.5, TABLE 6, TABLE 10, TABLE 16, TABLE 25, TABLE 40, TABLE 64, TABLE 160, TABLE 320, TABLE 400",
      "Form:":
        "Slip on, socket weld, blind, lapped, screwed, weld neck, reducing, spectacle, slip on boss, plate, plate blank, screwed boss. ",
    },
    chemical: {
      grade:
        "Stainless Steel Pr EN 1092-1 Flanges| Carbon Steel Pr EN 1092-1 Flanges| Nickel Alloys Pr EN 1092-1 Flanges",
      "Size :": "DN15 - DN2000",
      "Standard: ": "EN 1092",
      "Type:":
        "Weld Neck Flanges(Raised Face), EN Norm flanges, Loose Flanges, Plate Flanges, Blind Flanges Process: Forged, Stamped",
      "Pressure grade:": "PN6, PN10, PN16, PN25, PN40",
    },
    products_Flanges: {
      "BS 4504 Flanges": [
        " Plate Flanges Code 101",

        "Weld Neck Flanges Code 111",
        " Blind Flanges Code 105",

        "Slip On Flanges Code 112",

        " Thereated Flanges Code 113",
      ],
    },
  },
];

export const JISNormFlangesData = [
  {
    text1:
      "JIS Norm Flanges Manufacturers,Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Modi Metals is a dynamic group, which was delivered completed 10 years back to consider making offers of JIS Flanges measures in Weld Neck Flanges, Blind Flanges, Threaded Flanges, Loose or Lap Joint Flanges in all materials like Stainless Steel , Carbon Steel and High Nickel Alloys. We Manufacture, Export and Supply Flanges which meets with national and general quality gages and making base which has sorts of apparatus fitting in with general particular level and is especially equipped with a whole system of bleeding edge plasma refining sorts of mechanical gathering.",
    text3: "",
    img:require('../Images/FlangeImg/img10.png'),
    Specifications: {
      "STAINLESS STEEL FLANGE":
        "ASTM / ASME SA 182 F 304, 304L, 304H, 309H, 310H, 316, 316H, 316L, 316 LN, 317, 317L, 321, 321H, 347, 347 H",
      Range:
        "15 NB upto 600 NB in 150 LBS, 300 LBS, 400 LBS, 600 LBS, 900 LBS, 1500 LBS, 2500 LBS / TABLE 2.5, TABLE 6, TABLE 10, TABLE 16, TABLE 25, TABLE 40, TABLE 64, TABLE 160, TABLE 320, TABLE 400",
      "Form:":
        "Slip on, socket weld, blind, lapped, screwed, weld neck, reducing, spectacle, slip on boss, plate, plate blank, screwed boss. ",
      " Class : ":
        " 150#, 300#,400 #,600#,900#, 1500# & 2500 #.",
      " Size :": '1/8" NB TO 48"NB',
    },
    chemical: {
      grade:
        "Stainless Steel Pr EN 1092-1 Flanges| Carbon Steel Pr EN 1092-1 Flanges| Nickel Alloys Pr EN 1092-1 Flanges",
      "Size :": "DN15 - DN2000",
      "Standard: ": "EN 1092",
      "Type:":
        "Weld Neck Flanges(Raised Face), EN Norm flanges, Loose Flanges, Plate Flanges, Blind Flanges Process: Forged, Stamped",
      "Pressure grade:": "PN6, PN10, PN16, PN25, PN40",
    },
    products_Flanges: {
      "JIS B2220 Flanges": [
        " D & M 5kg SOP/SOH/BLIND1",
        "D & M 10kg SOP/SOH/BLIND",
        " D & M 16kg SOP/SOH/BLIND",
        "D & M 20kg SOP/SOH/BLIND",
      ],
    },
  },
];


export const UNINormFlangesData = [
  {
    text1:
      "UNI Plate Flanges Manufacturers,Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "UNI Flange Manufacturer Supplies Of UNI Flanges , UNI Flanges, UNI Forged Flange, UNI Flanges in Forged Steel, Stainless Steel, Carbon Steel C22.8, RST37.2, S235JR, P235GH, P245GH, P250GH, ASTM A105, ASTM A182 F304 (1.4306), F304L(1.4307), F316(1.4404), F316L(1.4404), F321(1.4541) and so forth.Stockist of Stainless Steel UNI PN6 Flanges, UNI Class 150 UNI Flange, UNI Pipe Flanges, Global Supplier of UNI Flanges, ASTM A182 SS UNI Flange, UNI Plate Flanges Dealer in India, UNI Blind Flanges, UNI Lapped joint Flanges, UNI Threaded Flange, UNI Plate Flange Stockist.",
    text3: "",
    img:require('../Images/FlangeImg/img11.png'),
    Specifications: {
      "STAINLESS STEEL FLANGE":
        "ASTM / ASME SA 182 F 304, 304L, 304H, 309H, 310H, 316, 316H, 316L, 316 LN, 317, 317L, 321, 321H, 347, 347 H",
      Range:
        "15 NB upto 600 NB in 150 LBS, 300 LBS, 400 LBS, 600 LBS, 900 LBS, 1500 LBS, 2500 LBS / TABLE 2.5, TABLE 6, TABLE 10, TABLE 16, TABLE 25, TABLE 40, TABLE 64, TABLE 160, TABLE 320, TABLE 400",
      "Form:":
        "Slip on, socket weld, blind, lapped, screwed, weld neck, reducing, spectacle, slip on boss, plate, plate blank, screwed boss. ",
      " Class : ":
        " 150#, 300#,400 #,600#,900#, 1500# & 2500 #.",
      "Size :": '1/8" NB TO 48"NB',
    },
    chemical: {
      grade:
        "Stainless Steel Pr EN 1092-1 Flanges| Carbon Steel Pr EN 1092-1 Flanges| Nickel Alloys Pr EN 1092-1 Flanges",
      "Size :": "DN15 - DN2000",
      "Standard: ": "EN 1092",
      "Type:":
        "Weld Neck Flanges(Raised Face), EN Norm flanges, Loose Flanges, Plate Flanges, Blind Flanges Process: Forged, Stamped",
      "Pressure grade:": "PN6, PN10, PN16, PN25, PN40",
    },
    products_Flanges: [
      "UNI 2276 PN6 Flanges",
      "UNI 2277 PN10 Flanges",
      "UNI 2278 PN16 Flange",
      "UNI 6089 PN10Flanges",
      "UNI 6089 PN16 FlangeS",
    ]

  },
];
export const DINNormFlangesData = [
  {
    text1:
      "Din Norm Flanges Manufacturers,Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Modi Metals is a dynamic group, which was set up finished 10 years back to consider making requesting of DIN Flanges gages in Weld Neck Flanges, Blind Flanges, Threaded Flanges, Loose or Lap Joint Flanges in all materials like Stainless Steel, Carbon Steel and High Nickel Alloys. We Manufacture, Export and Supply Flanges which meets with national and general quality benchmarks and making base which claims supplies changing as per general specific level and is all around equipped with an entire approach of front line plasma refining sorts of mechanical social gathering.",
    text3: "",
    img:require('../Images/FlangeImg/img12.png'),
    Specifications: {
      "STAINLESS STEEL FLANGE":
        "ASTM / ASME SA 182 F 304, 304L, 304H, 309H, 310H, 316, 316H, 316L, 316 LN, 317, 317L, 321, 321H, 347, 347 H",
      Range:
        "15 NB upto 600 NB in 150 LBS, 300 LBS, 400 LBS, 600 LBS, 900 LBS, 1500 LBS, 2500 LBS / TABLE 2.5, TABLE 6, TABLE 10, TABLE 16, TABLE 25, TABLE 40, TABLE 64, TABLE 160, TABLE 320, TABLE 400",
      "Form:":
        "Slip on, socket weld, blind, lapped, screwed, weld neck, reducing, spectacle, slip on boss, plate, plate blank, screwed boss. ",
      " Class : ":
        " 150#, 300#,400 #,600#,900#, 1500# & 2500 #.",
      " Size :": '1/8" NB TO 48"NB',
    },
    chemical: {
      grade:
        "Stainless Steel Pr EN 1092-1 Flanges| Carbon Steel Pr EN 1092-1 Flanges| Nickel Alloys Pr EN 1092-1 Flanges",
      "Size :": "DN15 - DN2000",
      "Standard: ": "EN 1092",
      "Type:":
        "Weld Neck Flanges(Raised Face), EN Norm flanges, Loose Flanges, Plate Flanges, Blind Flanges Process: Forged, Stamped",
      "Pressure grade:": "PN6, PN10, PN16, PN25, PN40",
    },
    products_Flanges: {
"Plate Flanges":[

 " DIN 2573 PN6",
"DIN 2576 PN10",
"DIN 2642 PN10",
],
"Welding Neck Flanges":[
"DIN 2631 PN6",
"DIN 2632 PN10",
"DIN 2633 PN16",
"DIN 2634 PN25",
"DIN 2635 PN40"
],
"Threaded Flanges":[
"  DIN 2565 PN6",
"DIN 2566 PN10"
],
"Blind Flanges":[
 " DIN 2527 PN10",
"DIN 2527 PN16"
],

    }

  },
];

export const ANSINormFlangesData = [
  {
    text1:
      "ANSI Norm Flanges Manufacturers,Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "The present and right standard is ASME B16.5. ANSI B16.5 is regular industry language is still alluded to widely by modelers, designers, makers and providers. What's more, in spite of the fact that the ANSI B16.5 standard does not in fact exist, it its comprehended as another approach to state ASME B16.5.ANSI B16.5 Class 150 FlangesANSI flanges are accessible at Dipti Metal Industries in class 150.The ANSI flanges in the class 150 determination cover slip-ons, weld necks, lap joints, blinds, strung and attachment weld flanges. ANSI flanges for class 150 are given by Dipti Metal Industries as forgings unless generally indicated.The B16.5 Standard characterizes the accompanying:",
    text3: "",
    img:require('../Images/FlangeImg/img7.jpg'),
    Specifications: {
      "STAINLESS STEEL FLANGE":
        "ASTM / ASME SA 182 F 304, 304L, 304H, 309H, 310H, 316, 316H, 316L, 316 LN, 317, 317L, 321, 321H, 347, 347 H",
      Range:
        "15 NB upto 600 NB in 150 LBS, 300 LBS, 400 LBS, 600 LBS, 900 LBS, 1500 LBS, 2500 LBS / TABLE 2.5, TABLE 6, TABLE 10, TABLE 16, TABLE 25, TABLE 40, TABLE 64, TABLE 160, TABLE 320, TABLE 400",
      "Form:":
        "Slip on, socket weld, blind, lapped, screwed, weld neck, reducing, spectacle, slip on boss, plate, plate blank, screwed boss. ",
      " Class : ":
        " 150#, 300#,400 #,600#,900#, 1500# & 2500 #.",
      "Size :": '1/8" NB TO 48"NB',
    },
    chemical: {
      grade:
        "Stainless Steel Pr EN 1092-1 Flanges| Carbon Steel Pr EN 1092-1 Flanges| Nickel Alloys Pr EN 1092-1 Flanges",
      "Size :": "DN15 - DN2000",
      "Standard: ": "EN 1092",
      "Type:":
        "Weld Neck Flanges(Raised Face), EN Norm flanges, Loose Flanges, Plate Flanges, Blind Flanges Process: Forged, Stamped",
      "Pressure grade:": "PN6, PN10, PN16, PN25, PN40",
    },
    products_Flanges: {
      "Weld Neck Flanges":[


        "Class 150",
"Class 300",
"Class 400",
"Class 600",
"Class 900",
"Class 1500",
"Class 2500",
"Class150 – Weld Neck , Series A",
"Class 150 – Weld Neck , Series B",
"Class 300 – Weld Neck& Blind, Series A",
"Class 150 – Weld Neck & Blind, Series B",
"Class 600 – Series A & B",
"Class 900 – Series A & B"
      ],
      "Slip On Flanges":[
        "Class 300",
        "Class 400",
        "Class 600",
        "Class 900",
        "Class 1500",
        "Class 2500",

      ],
      "Socket Weld Flanges":[

        "Class 300",
        "Class 400",
        "Class 600",
        "Class 900",
        "Class 1500",
        "Class 2500",
      ],
      'Threaded Flanges':[
        "Class 300",
        "Class 400",
        "Class 600",
        "Class 900",
        "Class 1500",
        "Class 2500",
      ],
      "Orifice Flanges":[
        "Class 300",
        "Class 600",
        "Class 900",
        "Class 1500",
        "Class 2500",
      ],
    }

  },
];

export const  Flange_Grade_alloys=[{

  heading:"Stainless Steel ",
  grade:[
"SS 304 ",

"SS 304L ",
"SS 304H ",

"SS 316 ",

"SS 316L ",

"SS 316Ti ",

"SS 310 ",

"SS 310S ",

"SS 321 ",

"SS 321H ",

"SS 317 ",

"SS 347 ",

"SS 347H ",
  ]

},{


  heading:"Alloy Steel",
  grade:[

  "  Alloy Steel",

"Nickel Alloys",

"Nickel 200",

"Nickel 201",

"Monel 400",

"Monel 500",

"Inconel 800",

"Inconel 825",

"Inconel 600",

"Inconel 625",

"Inconel 601",
  ]
},

{
  heading:"Carbon Steel ASTM A 234",

  grade:[

    "Carbon Steel ASTM A 234",
"Hastelloy C 276",

"Alloy 20",

"Titanium",

"Duplex Steel 2205",

"Copper Alloys",

"Aluminium",

"Copper",

"Brass",

'Gunmetal',

  ]
}


]


